module.exports = __webpack_public_path__ + "img/btn_next.5c380875.svg";